<template>
  <div>
    <el-dialog :title="titleMap[dialogStatus]" :visible.sync="dialogVisible" width="450px">
      <el-form class="post-main-container post-dialog-container" label-position="right">
        <el-form-item label="用户名：" prop="account">
          <el-input v-model="form.account"></el-input>
        </el-form-item>

        <el-form-item label="姓名：" prop="nickname">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>

        <el-form-item label="密码：" prop="password" v-show="dialogStatus === 'create'">
          <el-input v-model="form.password" type="password" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="确认密码：" prop="auditPassword" v-show="dialogStatus === 'create'">
          <el-input v-model="form.auditPassword" type="password" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="用户角色：" prop="refRole">
          <el-select v-model="form.refRole" placeholder="请选择角色">
            <el-option
              v-for="item in roles"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="dialogStatus === 'create'"
          type="primary"
          @click="createData"
          :loading="btnLoading"
        >
          创建
        </el-button>
        <el-button v-else type="primary" @click="updateData" :loading="btnLoading">提交</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateAdmin } from '@/api/admin'

export default {
  props: {
    roles: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialogStatus: 'create',
      dialogVisible: false,
      btnLoading: false,

      titleMap: {
        create: '创建管理员',
        update: '编辑管理员'
      },

      form: {
        code: '',
        account: '',
        nickname: '',
        password: '',
        auditPassword: '',
        refRole: ''
      },

      emptyForm: {}
    }
  },

  methods: {
    handleCreate() {
      this.$resetForm(this.form, this.emptyForm)

      this.dialogStatus = 'create'
      this.dialogVisible = true
    },

    handleUpdate(row) {
      this.$resetForm(this.form, row)

      this.dialogStatus = 'update'
      this.dialogVisible = true
    },

    createData() {
      this.btnLoading = true

      updateAdmin(this.form, 'create')
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false

          this.$message.success('提交数据成功')
          this.$emit('listenPostSuccess')
        })
        .catch(() => {
          this.btnLoading = false
        })
    },

    updateData() {
      this.btnLoading = true

      updateAdmin(this.form, 'update')
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false

          this.$message.success('提交数据成功')
          this.$emit('listenPostSuccess')
        })
        .catch(() => {
          this.btnLoading = false
        })
    }
  }
}
</script>
